import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={29} height={42} fill="none" {...props}>
        <Path
            fill={designSystem.colors.neutral900}
            stroke={designSystem.colors.neutral400}
            d="M27.906.5v7.74l-.048.1-15.12 32.077-.134.287H1.668l.338-.714L16.41 9.6H.5V.5h27.406Z"
        />
    </Svg>
);
export { SvgComponent as SevenIcon };
